import { tokens } from '@news-mono/design-tokens'
import React from 'react'
import {
    MeterPieChart,
    MeterPieChartItem,
} from '../../../components/MeterPieChart'
import {
    RaceSwingPercentContainer,
    StyledRaceSwingContainer,
} from './TheRaceSwing.styled'

interface TheRaceSwingProps {
    swing: number | null
}

export const TheRaceSwing = ({ swing }: TheRaceSwingProps) => {
    if (swing === null || swing === undefined) {
        return null
    }

    // Don't display % if swing is returned as 0 but if rounded down or up
    // should display the label
    const swingLabel = Math.round(swing * 10) / 10
    const min = -50
    const max = 50

    let start, end
    if (swingLabel > 0) {
        start = 0
        end = swingLabel
    } else if (swingLabel < 0) {
        start = swingLabel
        end = 0
    }

    return (
        <StyledRaceSwingContainer>
            {swing !== 0 && (
                <RaceSwingPercentContainer>{`${swingLabel.toFixed(
                    1,
                )}%`}</RaceSwingPercentContainer>
            )}
            <MeterPieChart
                min={min}
                max={max}
                innerCutoutRatio={0.6}
                items={
                    <>
                        <MeterPieChartItem
                            start={min}
                            end={max}
                            fill={'#E0E0E0'}
                        />
                        {start !== undefined && end !== undefined && (
                            <MeterPieChartItem
                                start={start}
                                end={end}
                                fill={
                                    swing > 0
                                        ? tokens.thenightly.colors.palette
                                              .neutral[100]
                                        : tokens.thenightly.colors.palette
                                              .neutral[50]
                                }
                            />
                        )}
                    </>
                }
            />
        </StyledRaceSwingContainer>
    )
}
